import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Topbar from '../../components/modules/navigation/Topbar';
import {Session as actionmodule} from '../../actions/index';
const {actions} = actionmodule;


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    logout: actions.logoutUser
  }, dispatch);
}



function mapStateToProps(state) {
  const {session} = state;

  return {
    session
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Topbar);



// WEBPACK FOOTER //
// ./src/containers/components/Topbar.js